// extracted by mini-css-extract-plugin
export default {"closeModalBtn":"imageModal_closeModalBtn__57JBL","closeIcon":"imageModal_closeIcon__NS2cM","modalImage":"imageModal_modalImage__uc6xY"};